import React from 'react';
import RedBullLogoIcon from './RedBullLogo.png';

interface RedbullLogoIconProps {
  width?: number;
}

const RedbullLogoIcon: React.FC<RedbullLogoIconProps> = ({ width = 140 }) => {
  return <img width={width} src={RedBullLogoIcon} alt="No logo" />;
};

export default RedbullLogoIcon;
